module.exports = __webpack_public_path__ + "img/JuicyFruit.57ce4bfa.webp";